<template>
  <div class="body">
    <round-images :banner="banner"></round-images>
    <div
      class="msg-box"
      type="white"
    >
      <div class="title" style="padding-top:50px;font-size:30px;padding-bottom:8px;font-family:middle;">
        標準GoogleTV OSを搭載
      </div>
      <div class="min-title" style="font-size:20px;margin-bottom:60px;font-family:light;">
        自宅のテレビが最新のスマートテレビに！テレビ買替えより低コストで高機能を実現！
      </div>
      <img
        class="main-image"
        :src="msg0"
      />
      <div class="min-images">
        <div
          class="min-image"
          v-for="(n, index) in msgMin"
          :key="index"
        >
          <img :src="n">
        </div>
      </div>
    </div>
    <div class="banner-outer">
      <img
        :src="banner1"
        class="banner"
      />
      <div class="box-inset">
        <div class="title">
          海外で日本の動画が観られる
        </div>
        <div class="min-title">
          日本VPNサービスとセットでご提供、海外で日本のIP制限動画が観られる
        </div>
      </div>
    </div>
    <!-- <div class="activity-logo">
      <div class="logo-inset">
        <div
          class="logo"
          v-for="(n, index) in newsLogo"
          :key="index"
        >
          <img
            :src="n.picUrl"
            @click="linkTo(n.linkUrl)"
          />
        </div>
        <div
          class="logo"
          v-for="(n, index) in newsLogo"
          :key="'+' + index"
        >
          <img
            :src="n.picUrl"
            @click="linkTo(n.linkUrl)"
          />
        </div>
      </div>
      <div class="btn">
        <span>その他の日本の動画アプリ</span>
      </div>
    </div> -->
    <div
      class="banner-outer"
      style="background: #eae9f2;padding-top:50px"
    >
      <img
        :src="msgBg0"
        class="banner1"
      />
      <div class="box-inset">
        <div
          class="title"
          style="color:#3E67B2;font-size:30px;padding-bottom:8px;font-family:middle;"
        >
          海外在住日本人のテレビ視聴のお悩みを解消！
        </div>
        <div
          class="min-title"
          style="color:#222;font-size:20px;font-family:light;"
        >
          日本の動画コンテンツが海外で観られない。<br />
          VPN設定の仕方がわからない！使いづらい！
        </div>
      </div>
    </div>
    <img
      class="block"
      :src="banner.data[6].picUrl"
    >
    <div class="msg-box">
      <div class="msg-title">
        海外の自宅は日本のIP環境
      </div>
      <div class="msg-text">
        BOX本体も、WiFiスポットも、日本のIP環境で接続が可能。コロナの巣ごもり生活に、<br />
        ご家族の皆さんが各自で好きな動画をお楽しみいただけます
      </div>
      <div class="msg-block-image">
        <img :src="msgImage0" />
      </div>
      <div class="msg-title" style="color:#000;">
        海外の自宅は日本のIP環境
      </div>
      <div class="msg-text" style="margin-bottom: 80px;">
        BOX本体も、WiFiスポットも、日本のIP環境で接続が可能。<br />
        コロナの巣ごもり生活に、ご家族の皆さんが各自で好きな動画をお楽しみいただけます。
      </div>
      <div class="msg-sub-title">
        海外生活はJ-DIRECT BOXで変わる<br />
        コロナ巣ごもりの時間つぶしに最高の楽しみ！
      </div>
      <div class="msg-flex-image">
        <div
          class="msg-flex-image-inset"
          v-for="(n, index) in msgImageFlexList"
          :key="index"
        >
          <img :src="n.url" />
          <p>{{ n.msg }}</p>
        </div>
      </div>
      <div class="msg-title" style="color:#000;margin-top:60px;">
        海外生活はJ-DIRECT BOXで変わる
      </div>
      <div class="msg-text" style="margin-bottom:60px;">
        コロナ巣ごもり生活に手軽な娯楽環境を提供いたします。<br />
        リビングで大画面で家族や夫婦で人気動画を見る、部屋で個別に動画を見るなど、<br />
        それぞれのご家庭に最適なエンタメ環境を実現致します。
      </div>
    </div>
    <div
      class="msg-box"
      style="background:#050B24"
    >
      <div
        class="msg-title"
        style="color:#fff;"
      >
        モバイル端末も日本のIP環境
      </div>
      <div
        class="msg-text"
        style="color:#fff;"
      >
        日本のIP環境になったWiFiスポットに接続すれば、モバイル端末でも日本IP制限の動画が観られる
      </div>
      <div class="msg-block-image">
        <img :src="msgImage1" />
      </div>
    </div>
    <div
      class="msg-title"
      style="color:#000;text-align:center;"
    >
      モバイル端末も日本のIP環境
    </div>
    <div
      class="msg-text"
      style="color:#000;text-align:center;margin-bottom:60px;"
    >
      J-DIRECT BOXはWiFiルーター内蔵。BOXから発するWiFi電波につなぐだけで、お手持ち<br />
      のモバイル端末が簡単にVPN接続できます。<br />
      それらの端末でお好みの日本IP制限動画コンテンツが楽しめます。
    </div>
    <div
      class="msg-box"
      type="orange"
    >
      <div class="title">
        おススメ
      </div>
      <div class="min-title" style="margin-bottom:20px;">
        Fire TV Stick 、最新のMi TV Stickを購入、寝室も子供部屋も日本と同じテレビライフを実現！
      </div>
      <div>
        <img
          :src="msg"
          style="width:625px;overflow:hidden;cursor:pointer;"
          @click="gostick"
        />
        <img
          :src="msg11"
          style="width:625px;overflow:hidden;margin-left:61px;"
        />
      </div>
       <div
      class="msg-title"
      style="color:#000;margin-top:60px;"
    >
      おオススメ端末（他社製）
    </div>
    <div
      class="msg-text"
      style="color:#000;margin-bottom:60px;"
    >
      ご家庭のそれぞれの場所でコンテンツを楽しむために、Fire TV Stick、Google TV Stickなどの製品も。<br />
      J-DIRECT BOXから出るWiFiに接続すれば、日本IP制限アプリを自由にお楽しみいただけます。
    </div>
    </div>
    <div class="banner-outer">

      <img
        :src="banner2"
        class="banner"
      />
      <div class="box-inset">
        <img
          :src="jLogo"
          class="j-logo"
        />
        <div class="title">
          日本VPNプロバイダ
        </div>
        <div class="min-title">
          BOX本体に日本VPNルーターを内蔵、BOXに接続するテレビでも、モバイル機器でも<br />
          日本国内限定配信の動画を海外から視聴可能
        </div>
      </div>
    </div>
    <div
      class="msg-title"
      style="color:#000;margin-top:60px;text-align:center;"
    >
      J-DIRECT は日本VPNプロバイダです
    </div>
    <div
      class="msg-text"
      style="color:#000;margin-bottom:60px;text-align:center;"
    >
      BOX本体に日本VPNルーターを内蔵・BOXに接続するテレビでも、モバイル機器でも日本国内限定配信の動画を海外から視聴可能<br />
      VPNとは「Virtual Private Network」の略。J-DIRECTはVPNサービスを提供するプロバイダです。海外のご自宅に仮想日本のインターネット環境を実現します。
    </div>
    <div
      class="msg-box"
      type="linear"
    >
      <div class="logo">
        <img :src="logo1" />
      </div>
      <div class="title">
        海外地域情報をテレビで見る
      </div>
      <div class="min-title">
        海外在住日本人向けのテレビ新媒体現地媒体と連携し、お住まいの地域の<br />
        最新情報をテレビ画面にプッシュ配信
      </div>
      <img
        :src="msg2"
        class="main-image"
      />
    </div>
    <div
      class="msg-title"
      style="color:#000;margin-top:60px;text-align:center;"
    >
      J-NAVIで海外地域情報をテレビで見られます
    </div>
    <div
      class="msg-text"
      style="color:#000;margin-bottom:60px;text-align:center;"
    >
      海外在住日本人向けの全く新しいメディアです。<br />
      お住いの地域の最新情報をテレビ画面にプッシュ配信、必要な最新情報を簡単便利<br />
      に大きな文字で見ることができます。
    </div>
    <div
      class="msg-box"
      type="dark"
    >
      <div class="logo">
        <img :src="logo2" />
      </div>
      <div class="title">
        GoogleアシスタントBuilt-in
      </div>
      <div class="min-title">
        テレビを見ながら声で動画を検索、テレビの楽しみ方がもっと広がる
      </div>
      <img
        :src="msg3"
        class="main-image"
      />
    </div>
    <div
      class="msg-title"
      style="color:#000;margin-top:60px;text-align:center;"
    >
      GoogleアシスタントBuilt-in
    </div>
    <div
      class="msg-text"
      style="color:#000;margin-bottom:60px;text-align:center;"
    >
      テレビを見ながら声で動画を検索、テレビの楽しみ方がもっと広がります。
    </div>
    <div class="banner-outer">

      <img
        :src="banner3"
        class="banner"
      />
      <div class="box-inset">
        <img
          :src="logo3"
          class="j-logo"
        />
        <div
          class="title"
          style="color:#222222;"
        >
          スマホの画面をテレビに映す
        </div>
        <div
          class="min-title"
          style="color:#222222;"
        >
          ミラーリング方式で画面をTVに映すAirScreenアプリをプリセット<br />
          大画面テレビで家族団らんの時間を楽しめる
        </div>
      </div>
    </div>
    <div
      class="msg-title"
      style="color:#000;margin-top:60px;text-align:center;"
    >
      AirScreenでスマホの画面をテレビに映します
    </div>
    <div
      class="msg-text"
      style="color:#000;margin-bottom:60px;text-align:center;"
    >
      ミラーリング方式でスマホの画面をテレビに映すAirScreenアプリをプリセット。<br />
      大画面テレビで家族写真を映したりと、様々な使い方ができます。
    </div>
    <div class="banner-outer">

      <img
        :src="banner4"
        class="banner"
      />
      <div class="box-inset">
        <div
          class="title"
          style="color:#222222;"
        >
          業界初の内蔵スピーカー
        </div>
        <div
          class="min-title"
          style="color:#222222;"
        >
          内蔵スピーカーはテレビ画面を見ずにラジオなど音声だけを聞きたい場合に便利！
        </div>
      </div>
    </div>
    <div
      class="msg-box"
      type="white"
      style="background:#fff"
    >
      <div class="title">
        業界初の内蔵スピーカー
      </div>
      <div class="min-title">
        内蔵スピーカーはテレビ画面を消して音声だけを聞きたい場合に便利です。<br />
        家事をしながら、仕事をしながら、画面を見つめること無く音声コンテンツを楽しめます
      </div>
    </div>
    <div
      class="msg-box"
      type="white"
      style="background:#fff"
    >
      <div class="title">
        4K HDR超高画質
      </div>
      <div class="min-title">
        4Kテレビに合わせて、3840×2160の解像度で自然でリアルな描写が可能。<br />
        Youtubeの4K動画視聴に最適!
      </div>
    </div>
    <img
      :src="banner5"
      class="block"
    />
    <div
      class="msg-box"
      type="white"
      style="background:#fff"
    >
      <div class="title">
        4K HDR超高画質にも対応
      </div>
      <div class="min-title">
        4Kテレビに合わせて、3840ｘ2160の解像度で自然でリアルな描写が可能。<br />
        YouTubeの4K動画視聴に最適！
      </div>
    </div>
    <div
      class="msg-box"
      type="white"
      style="background:#fff"
    >
      <div class="title">
        4K 60fpsコーデックでスムーズな動画再生
      </div>
      <div class="min-title">
        J-DIRECT BOXは、通常のTV BOXの2倍の画像処理能力の最大60 fpsに対応。<br />
        スポーツ観戦やゲームでより自然でスムーズな映像を楽しめます
      </div>
      <img
        :src="msg4"
        class="main-image"
      />
      <div
        class="msg-box"
        type="white"
        style="background:#fff"
      >
        <div class="title">
          4K 60fpsコーデック
        </div>
        <div class="min-title">
          J-DIRECT BOXは、通常のTV BOXの2倍の画像処理能力に相当する最大60fpsに対応。<br />
          スポーツ観戦やゲームなどで、より自然でスムーズな映像を楽しめます。
        </div>
      </div>
    </div>
    <div class="banner-outer">

      <img
        :src="banner6"
        class="banner"
      />
      <div class="box-inset">
        <div
          class="title"
          style="padding-top:.5rem;padding-left:4.5rem;text-align:left;"
        >
          ハイスペックチップを採用
        </div>
        <div
          class="min-title"
          style="padding-left:4.5rem;text-align:left;"
        >
          2GB＋16GB 大容量メモリストレスのない高速操作を実現
        </div>
      </div>
      <div
        class="msg-box"
        type="white"
        style="background:#fff"
      >
        <div class="title">
          ハイスペックチップを採用
        </div>
        <div class="min-title">
          処理能力が速く、消費電力は省エネ設計、高耐久性のハイスペックチップを採用。<br />
          2GB+16GB大容量メモリも搭載し、ストレスのない高速操作を実現。
        </div>
      </div>
    </div>
    <div class="show-box">
      <div class="show-box-inset">
        <div class="msg-area">
          <div class="msg-area-title">
            テレビをもっと<br />スマートに!
          </div>
          <div class="msg-area-inset">
            エンターテイメント<br />
            の可能性を広げる<br />
            リッチなインターフェース
          </div>
        </div>
        <div class="box-image">
          <img :src="box" />
        </div>
      </div>
      <div
        class="msg-box"
        type="white"
        style="background:#fff"
      >
        <div class="title">
          テレビをもっとスマートに！
        </div>
        <div class="min-title">
          エンターテイメントの可能性を広げるリッチなインターフェイス<br />
          コンパクトなボディにハイパフォーマンスな最新技術・使いやすさにこだわった設計
        </div>
      </div>
    </div>
    <img
      :src="banner7"
      class="block"
    />
    <div
      class="msg-box"
      type="white"
      style="background:#fff"
    >
      <div class="title">
        -DIRECT BOX　簡単！便利！多機能！<br />
        海外生活の必需品
      </div>
      <div class="min-title">
        J-DIRECT ：一発で日本のVPNに接続・BOXもWiFiも日本IP接続<br />
        Google Assistant：動画視聴中にマイクで検索　声だけで動画や音楽を再生<br />
        J-NAVI：海外地域情報をテレビで見る　次世代ハイブリッドキャスト
      </div>
    </div>
    <div
      class="msg-box"
      type="white"
      style="padding-bottom:0px"
    >
      <div class="title">
        J-DIRECT BOX 同梱一覧
      </div>
      <img
        :src="msg5"
        class="main-image"
        style="margin-bottom:0px;padding-bottom:76px;"
      />
    </div>
    <div class="banner-outer">
      <img
        :src="banner8"
        class="banner"
      />
      <img
        :src="btn"
        class="btn"
      />
    </div>
    <div
      class="msg-box"
      type="orange"
      style="background:#fff;"
    >
      <div class="title">
        無料プレゼントをセット
      </div>
      <div class="min-title">
        J-Direct BOXを購入すると<span style="color:#d3161b;">129USD</span>分の無料プレゼント！
      </div>
      <img
        :src="msg6"
        class="main-image"
      >
    </div>
  </div>
</template>
<script>
import { banner, newsLogo } from '../../images/news/index'
import { banner1, msgBg0, msgImageFlexList, msgImage0, msgImage1, jLogo } from '../../images/vpn/index'
import { box, btn, msg , msg11 , msg0, msg1, msg2, msg3, msg4, msg5, msg6, msgMin, banner2, banner3, banner4, banner5, banner6, banner7, banner8, logo1, logo2, logo3 } from '../../images/box/index'
import roundImages from '../../public-modules/round-images/index'
export default {
  data () {
    return {
      banner,
      banner2,
      banner3,
      banner4,
      banner5,
      banner6,
      banner7,
      banner8,
      btn,
      jLogo,
      box,
      newsLogo,
      banner1,
      logo1,
      logo2,
      logo3,
      msg,
      msg11,
      msg0,
      msg1,
      msg2,
      msg3,
      msg4,
      msg5,
      msg6,
      msgBg0,
      msgImage0,
      msgImage1,
      msgImageFlexList,
      msgMin
    }
  },
  components: {
    roundImages
  },
  methods: {
    linkTo (url) {
      window.open(url)
    },
    gostick(){
      window.location.href="https://www.amazon.co.jp/Fire-TV-Stick-4K-HDR%E5%AF%BE%E5%BF%9C-Alexa%E5%AF%BE%E5%BF%9C%E9%9F%B3%E5%A3%B0%E8%AA%8D%E8%AD%98%E3%83%AA%E3%83%A2%E3%82%B3%E3%83%B3%E4%BB%98%E5%B1%9E/dp/B079QRQTCR/ref=sr_1_1?__mk_ja_JP=%E3%82%AB%E3%82%BF%E3%82%AB%E3%83%8A&crid=1NU825DLDGPDR&dchild=1&keywords=%E3%83%95%E3%82%A1%E3%82%A4%E3%82%A2%E3%82%B9%E3%83%86%E3%82%A3%E3%83%83%E3%82%AF4k&qid=1603939657&sprefix=%E3%83%95%E3%82%A1%E3%82%A4%E3%82%A2%E3%82%B9%E3%83%86%E3%82%A3%E3%83%83%E3%82%AF4%2Caps%2C336&sr=8-1"
    }
  }
}
</script>
<style scoped>
.msg-box {
  width: 100%;
  min-width: 1100px;
  box-sizing: border-box;
  padding-top: 50px;
  text-align: center;
}
.msg-title {
  color: #036ca8;
  font-size: 30px;
  font-weight: bold;
  padding-bottom: 8px;
  font-family: middle;
}
.msg-text {
  font-size: 20px;
  font-family: light;
}
.msg-block-image{
  margin-bottom: 80px;
}
.msg-block-image img {
  display: block;
  width: 1100px;
  margin: 0 auto;
}
.msg-sub-title {
  color: #2eb5e7;
  font-size: 30px;
  font-weight: bold;
  line-height: 45px;
  margin-bottom: 50px;
  padding-bottom: 8px;
  font-family: middle;
}
.msg-flex-image {
  width: 1100px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.msg-flex-image-inset {
  width: 350px;
  font-size: 20px;
  line-height: 35px;
  text-align: center;
  font-family: light;
}
.msg-flex-image-inset img {
  width: 350px;
  display: block;
}
.banner-outer {
  width: 100%;
  position: relative;
  min-width: 1100px;
  margin: 0 auto;
}
.banner {
  width: 100%;
  height: auto;
  display: block;
}
.banner1 {
  width: 1100px;
  margin: 0 auto;
  height: auto;
  display: block;
}
.btn {
  cursor: pointer;
  position: absolute;
  width: 12%;
  bottom: 20%;
  left: 21%;
}
.title,
.min-title {
  text-align: center;
}
.title {
  font-size: 0.4rem;
  font-weight: bold;
  padding-bottom: 8px;
  font-family: middle;
}
.min-title {
  font-size: 0.2rem;
  font-family: light;
}
.j-logo {
  width: 3rem;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.2rem;
}
.box-inset {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  color: #ffffff;
  box-sizing: border-box;
  padding: 1rem 0;
}
.activity-logo {
  background: #09131c;
  width: 100%;
  overflow: hidden;
  position: relative;
  height: 500px;
  padding: 50px 0;
}
.activity-logo .btn{
  margin-left: 18%;
  width: 509px;
  height: 74px;
  background: #FEFEFE;
  border: 1px solid #000000;
  border-radius: 37px;
  text-align: center;
}
.activity-logo .btn span{
  font-size: 30px;
  font-family: middle;
  font-weight: bold;
  color: #09152F;
  line-height: 74px;
}
@keyframes iconrun {
  0% {
    left: 0px;
  }
  100% {
    left: -3360px;
  }
}
.logo-inset {
  width: 6720px;
  position: absolute;
  left: 0;
  top: 50px;
  animation: iconrun 30s infinite linear;
}
.logo {
  display: inline-block;
  margin: 0 15px;
}
.logo img {
  display: block;
  width: 250px;
  height: 150px;
  cursor: pointer;
}
.logo-inset .logo:nth-child(1),
.logo-inset .logo:nth-child(13) {
  margin-left: 0;
}
.logo-inset .logo:nth-last-child(1),
.logo-inset .logo:nth-child(24) {
  margin-right: 0;
}
.msg-box {
  width: 100%;
  min-width: 1100px;
  text-align: center;
  padding: 50px 0;
}
.msg-box .title {
  font-size: 30px;
  font-weight: bold;
  padding-bottom: 8px;
  font-family: middle;
}
.msg-box .min-title {
  font-size: 20px;
  font-family: light;
  /*font-weight: bold;*/
}
.msg-box .main-image {
  display: block;
  width: 1100px;
  margin: 30px auto;
}
.msg-box[type='white'] {
  background: #ebebeb;
  color: #222222;
}
.msg-box[type='orange'] {
  background: #ebebeb;
  color: #ff6709;
}
.msg-box[type='dark'] {
  background: #14192d;
  color: #fff;
  padding-bottom: 0;
}
.msg-box[type='dark'] .main-image {
  width: 80%;
  min-width: 1000px;
  margin: 50px auto;
  margin-bottom: 0;
}
.msg-box[type='linear'] {
  background: linear-gradient(-49deg, #03b6da, #2d36bf);
  color: #fff;
}
.msg-box[type='white'] .min-title {
  color: #434343;
}
.msg-box[type='orange'] .min-title {
  color: #434343;
}
.min-images {
  width: 900px;
  margin-top: 30px;
  margin: 0 auto;
}
.min-image {
  display: inline-block;
  margin: 0 12.5px;
  width: 200px;
}
.min-image img {
  display: block;
  width: 100%;
  height: auto;
}
.block {
  display: block;
  width: 100%;
  min-width: 1100px;
}
.msg-box .logo {
  height: 35px;
  margin: 0 auto;
}
.msg-box .logo img {
  height: 100%;
  width: auto;
  display: block;
  margin: 0 auto;
}
.show-box {
  width: 100%;
  min-width: 1100px;
}
.show-box-inset {
  width: 1100px;
  margin: 0 auto;
  display: flex;
  font-size: 30px;
  padding: 50px 0;
  padding-bottom: 8px;
  font-family: middle;
}
.msg-area {
  flex: 1;
  padding-right: 80px;
}
.box-image {
  flex: 2;
}
.box-image img {
  display: block;
  width: 100%;
}
.msg-area-title {
  font-weight: bold;
  font-size: 40px;
  color: #02bdb2;
  margin-top: 40px;
}
.msg-area-inset {
  font-weight: bold;
  font-size: 20px;
  margin-top: 50px;
  font-family: light;
}
</style>


// WEBPACK FOOTER //
// src/components/box/index.vue